import { useQuery } from "@tanstack/react-query"
import { fetcher } from "../fetcher"

export type TransactionsPaymentRequestCardDetailsApiResponse = {
  url: string
}

type HookParams = {
  paymentRequestId: string
}

export function useTransactionPaymentRequestCardDetails({ paymentRequestId }: HookParams) {
  return useQuery<TransactionsPaymentRequestCardDetailsApiResponse>({
    queryKey: [`paymentRequest/${paymentRequestId}/cardData`],
    queryFn: async () => {
      const response = await fetcher(
        `/Transaction/PaymentRequest/${paymentRequestId}/CardData`,
        {
          method: "GET",
        },
        {
          useAccessToken: true,
          doNotLogOutOn401: true,
        }
      )
      const responseJson = await response.json()

      return responseJson
    },
    enabled: false,
  })
}
